import { useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { Button, Divider, Stack, TextField } from "@mui/material";
import { useUpdateElementMutation } from "@/api/templatesApi";
import { Page, WebsiteElement } from "@/types";

interface Props {
  selectedElement: Page | null;
}

type PageElement = WebsiteElement & {
  title: string;
  url?: string;
};

const PageSettings = ({ selectedElement }: Props) => {
  const { templateId } = useParams<{ templateId: string }>();
  const [updateElement] = useUpdateElementMutation();

  if (!selectedElement || selectedElement.type !== "page") {
    return null;
  }

  const pageElement = selectedElement as PageElement;

  return (
    <Formik
      enableReinitialize
      initialValues={
        {
          title: pageElement?.title ?? "",
          url: pageElement?.url ?? "",
        } as Partial<Page>
      }
      onSubmit={async (values: Partial<Page>) => {
        await updateElement({
          templateId,
          payload: {
            ...pageElement,
            title: values.title ?? pageElement?.title ?? "",
            url: values.url ?? pageElement?.url ?? "",
          },
        });
      }}
    >
      {({ values, handleChange }) => (
        <Form>
          <Stack spacing={2}>
            <TextField size="small" name="title" label="Título" value={values.title ?? ""} onChange={handleChange} />
            <TextField size="small" name="url" label="URL" value={values.url ?? ""} onChange={handleChange} />
            <Button variant="contained" color="primary" type="submit">
              Guardar
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default PageSettings;
